import { inject, observer } from 'mobx-react';
import moment from "moment";
import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.scss";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { ChevronLeft, ChevronRight } from "react-feather";
import { Button, ButtonGroup, Card, CardBody, Modal, ModalBody, ModalHeader } from "reactstrap";
import "../../assets/scss/plugins/calendars/react-big-calendar.scss";
import classnames from "classnames";
import "../../assets/scss/pages/common.scss";
import { withFirebase } from '../../services/Firebase';
import AddEventButton from "./AddEventButton";
import ScheduleMeetingWizard from "./components/ScheduleMeetingWizard";

const DragAndDropCalendar = withDragAndDrop(Calendar)
const localizer = momentLocalizer(moment)
const eventColors = {
  business: "bg-success",
  work: "bg-warning",
  personal: "bg-danger",
  others: "bg-primary"
}

class Toolbar extends React.Component {
  render() {
    return (
      <div className="calendar-header mb-2 d-flex justify-content-between flex-wrap">
        <div>
          <AddEventButton />
        </div>
        <div className="text-center view-options mt-1 mt-sm-0 ml-lg-5 ml-0">
          <ButtonGroup>
            <button
              className={`btn ${
                this.props.view === "month"
                  ? "btn-primary"
                  : "btn-outline-primary text-primary"
              }`}
              onClick={() => {
                this.props.onView("month")
              }}
            >
              Month
            </button>
            <button
              className={`btn ${
                this.props.view === "week"
                  ? "btn-primary"
                  : "btn-outline-primary text-primary"
              }`}
              onClick={() => {
                this.props.onView("week")
              }}
            >
              Week
            </button>
            <button
              className={`btn ${
                this.props.view === "day"
                  ? "btn-primary"
                  : "btn-outline-primary text-primary"
              }`}
              onClick={() => {
                this.props.onView("day")
              }}
            >
              Day
            </button>
          </ButtonGroup>
        </div>
        <div className="month-label d-flex flex-column text-center text-md-right mt-1 mt-md-0">
          <div className="calendar-navigation">
            <Button
              className="btn-icon rounded-circle"
              size="sm"
              color="primary"
              onClick={() => this.props.onNavigate("PREV")}
            >
              <ChevronRight size={15} />
            </Button>
            <div className="month d-inline-block mx-75 text-bold-500 font-medium-2 align-middle">
              {this.props.label}
            </div>
            <Button
              className="btn-icon rounded-circle"
              size="sm"
              color="primary"
              onClick={() => this.props.onNavigate("NEXT")}
            >
              <ChevronLeft size={15} />
            </Button>
          </div>
        </div>
      </div>
    )
  }
}


@withFirebase
  @inject('createMeetingStore', 'calendarStore', 'sessionStore')
@observer
class CalendarApp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sliderVisibility: false,
      events: [],
      views: {
        month: true,
        week: true,
        day: true
      },
      eventInfo: null
    }
  }

  async componentDidMount() {
    //await this.props.fetchEvents()
    const { calendarStore , firebase, sessionStore } = this.props;
    const { authUser } = sessionStore;
    sessionStore.setContentSharing("meeting");
    calendarStore.loadCalendar(authUser, firebase);
  }

  handleEventColors = event => {
    return { className: eventColors[event.label] }
  }

  moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
    const { events } = this.state
    const idx = events.indexOf(event)
    let allDay = event.allDay
    if (!event.allDay && droppedOnAllDaySlot) {
      allDay = true
    } else if (event.allDay && !droppedOnAllDaySlot) {
      allDay = false
    }
    const updatedEvent = { ...event, start, end, allDay }
    const nextEvents = [...events]
    nextEvents.splice(idx, 1, updatedEvent)
    this.setState({
      events: nextEvents
    })
    this.props.updateDrag(updatedEvent)
  }

  resizeEvent = ({ event, start, end }) => {
    const { events } = this.state
    const nextEvents = events.map(existingEvent => {
      return existingEvent.id === event.id
        ? { ...existingEvent, start, end }
        : existingEvent
    })

    this.setState({
      events: nextEvents
    })

    this.props.updateResize({ ...event, start, end })
  }

  handleSelectEvent = o => {
    this.setState({
      eventInfo: o,
      meetingId: o.id,
      sliderVisibility: true
    })
  }

  handleSelectSlot = (startTime, endTime) => {
    debugger
  }

  onCreateSuccess = () =>{
    this.setState({sliderVisibility: false});
  }

  toggleSlider = () => {
    this.setState(prevState => ({
      sliderVisibility: !prevState.sliderVisibility
    }))
  }

  render() {
    const { views, sidebar, meetingId } = this.state
    const { meetingList } = this.props.calendarStore;
    const events = meetingList ? meetingList.map(meeting => {
      const { startTime, endTime } = meeting
      if(startTime != null){
        const startT = moment(startTime, 'x').toDate();
        const endT = moment(endTime, 'x').toDate();
        return {
          id: meeting.uid,
          title: meeting.title,
          start: startT,
          end: endT,
          label: "business",
          allDay: false,
          selectable: true
        } 
      }
    }) : []

    // const modal = (<Modal
    //   isOpen={this.state.sliderVisibility}
    //   toggle={this.toggleSlider}
    //   className="modal-dialog-centered modal-xl"
    // >
    //   <ModalBody>
    //     <ScheduleMeetingWizard
    //       onCreateSuccess={this.onCreateSuccess}
    //       meetingId={meetingId}
    //       newMeetingPage={false}
    //       togglesliderVisibility={this.toggleSlider}
    //     />
    //   </ModalBody>
    // </Modal>)


    return (
      <div className="app-calendar">
        <div
          className={`app-content-overlay ${sidebar ? "show" : "hidden"}`}
          onClick={() => {
            this.props.handleSidebar(false)
            this.props.handleSelectedEvent(null)
          }}
        ></div>
        <Card>
          <CardBody>
            <DragAndDropCalendar
              localizer={localizer}
              events={events}
              // onEventDrop={this.moveEvent}
              // onEventResize={this.resizeEvent}
              startAccessor="start"
              endAccessor="end"
              resourceAccessor="url"
              views={views}
              components={{ toolbar: Toolbar }}
              eventPropGetter={this.handleEventColors}
              popup={true}
              onSelectEvent={o => {
                this.handleSelectEvent(o)
              }}
              onSelectSlot={({ start, end }) => {
                this.handleSelectSlot(start, end);
              }}
              selectable={true}
            />
          </CardBody>
        </Card>
        <div className='animation-slider'>
          {
            this.state.sliderVisibility
            ? <ScheduleMeetingWizard
                show={this.state.sliderVisibility}
                meetingId={meetingId}
                onCreateSuccess={this.onCreateSuccess}
                toggleSliderVisibility={this.toggleSlider}
              />
            : null
          }
          <div
            className={classnames("animation-slider-overlay", {
              show: this.state.sliderVisibility
            })}
            onClick={() => this.toggleSlider(false)}
          />
        </div>  
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    app: state.calendar
  }
}

export default CalendarApp;


{/* <AddEventSidebar
  sidebar={sidebar}
  handleSidebar={this.props.handleSidebar}
  addEvent={this.props.addEvent}
  events={this.state.events}
  eventInfo={this.state.eventInfo}
  selectedEvent={this.props.handleSelectedEvent}
  updateEvent={this.props.updateEvent}
  // resizable
/> */}